// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__RNhrI","brand":"Navbar_brand__p8ZdV","links_list":"Navbar_links_list__Pt2yv","active":"Navbar_active__lqLpv","menu_button":"Navbar_menu_button__8YPuf"};